import { useTheme } from 'styled-components';

import Checkbox from '@components/Checkbox';
import { PaletteColor } from '@utils/types';

import {
  SingleSelectionFilterWrapper,
  SingleSelectionCheckboxContainer,
} from './SingleSelectionFilterStyle';

export interface SingleSelectionFilterProps {
  title: string;
  subTitle?: string | number;
  handleCheckBoxChange: (e: boolean) => void;
  checked: boolean;
  className?: string;
  name?: string;
  mode?: 'controlled' | 'uncontrolled';
}

const SingleSelectionFilter = ({
  title,
  subTitle,
  handleCheckBoxChange,
  checked,
  className,
  name,
  mode = 'uncontrolled',
}: SingleSelectionFilterProps) => {
  const { palette } = useTheme();
  return (
    <SingleSelectionFilterWrapper>
      <SingleSelectionCheckboxContainer className={className}>
        <Checkbox
          title={title}
          subTitle={subTitle}
          className='filters-checkbox'
          onChange={handleCheckBoxChange}
          value={checked}
          checked={checked}
          name={name}
          mode={mode}
          outlineColor={palette.NL800 as PaletteColor}
          labelAs='h4'
          labelStyle={{
            color: palette.NL800,
            lineHeight: 'normal',
            marginLeft: '2px',
          }}
          subTitleStyle={{
            color: palette.NL300,
            lineHeight: 'normal',
            opacity: 1,
          }}
        />
      </SingleSelectionCheckboxContainer>
    </SingleSelectionFilterWrapper>
  );
};

export default SingleSelectionFilter;
